import { SubsectionButtonOption } from '~/core/enums';
import { SectionTypes } from '~/core/enums/section-type-enum';
import { ApplianceSectionType, RetailerFileSettings } from '~/core/models';

export const cleanCompanyCode = (companyCode: string): string =>
  companyCode
    .replaceAll(' ', '-')
    .replace(/[^\w-]/g, '')
    .toLowerCase();

export const isOptionByApplianceSectionEnabled = (
  sectionType: ApplianceSectionType,
  option: SubsectionButtonOption,
  retailerFileSettings?: RetailerFileSettings
): boolean =>
  (sectionType &&
    option &&
    retailerFileSettings?.subsectionOptions?.[sectionType]?.[option]) ??
  false;

export const isCookingApplianceOptionEnabled = (
  retailerFileSettings: RetailerFileSettings | undefined,
  option: SubsectionButtonOption
): boolean =>
  isOptionByApplianceSectionEnabled(
    SectionTypes.cooking_appliance,
    option,
    retailerFileSettings
  );

export const isFaucetOptionEnabled = (
  retailerFileSettings: RetailerFileSettings | undefined,
  option: SubsectionButtonOption
): boolean =>
  isOptionByApplianceSectionEnabled(
    SectionTypes.faucet,
    option,
    retailerFileSettings
  );
